import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { CustomerService } from '../../services/customer.service';
import { ErrorService } from '../../services/error.service';
import { OrderTemplateService } from '../../services/order-template.service';
import { SpinnerService } from '../../services/spinner.service';
import { UserService } from '../../services/user.service';

@Component({
	selector: 'app-recent-templates-modal',
	templateUrl: './recent-templates-modal.html'
})

export class RecentTemplatesModalComponent implements OnInit {
	public dataSource = new MatTableDataSource<any>();
	public displayedColumns: string[] = ['name', 'origin', 'destination', 'action'];
	public numberOfTemplatesToGet = 10;
	public searchCriteria = '';
	public searchCriteriaChange: Subject<string> = new Subject<string>();
	public selectedCustomer: any;
	public user: any;

	constructor(public dialogRef: MatDialogRef<RecentTemplatesModalComponent>,
				@Inject(MAT_DIALOG_DATA) public data: any,
				private _CustomerService: CustomerService,
				private _ErrorService: ErrorService,
				private _OrderTemplateService: OrderTemplateService,
				private _UserService: UserService,
				private _router: Router,
				private _spinnerService: SpinnerService) {
		this.searchCriteriaChange.pipe(
			debounceTime(500),
			distinctUntilChanged()
		).subscribe((userSearch) => {
			this.searchCriteria = userSearch;
			this.getRecentTemplates();
		});
	}

	addToCart(template): void {
		if (this.data.hasOwnProperty('addToCart')) {
			this.data.addToCart({template: template, action: 'ADD_TO_CART'});
		}
	}

	closeModal(): void {
		this.dialogRef.close();
	}

	editTemplate(t): void {
		this.dialogRef.close();
		this._router.navigate(['order-templates/template'], {queryParams: {template: t.id, isTemplate: true}});
	}

	getRecentTemplates(): void {
		this._spinnerService.startSpinner();
		const customerId = this.selectedCustomer ? this.selectedCustomer.id : this.user.primaryCustomerId;
		this._OrderTemplateService.getRecentTemplates(customerId, this.numberOfTemplatesToGet, this.searchCriteria).subscribe(response => {
			this._spinnerService.stopSpinner();
			this.dataSource.data = response.sort((a, b) => {
				return b.lastUsed.timeStamp - a.lastUsed.timeStamp;
            });
            this.dataSource.data.forEach((template) => {
                template.validTemplate = this.isValidTemplate(template);
            });

		}, error => {
			this._spinnerService.stopSpinner();
			this._ErrorService.error(error, 'getRecentOrders Failed', 'modal');
		});
	}

	ngOnInit(): void {
		this.selectedCustomer = this._CustomerService.getSelectedCustomer();
		this.user = this._UserService.getUser();

		this.getRecentTemplates();
	}

	onSearchCriteriaChanged(text: string): void {
		if ((text && text.length > 1) || !text || (text && text.length === 0)) {
			this.searchCriteriaChange.next(text);
		}
	}

	selectTemplate(template): void {
		this.dialogRef.close({
			template: template,
			action: 'SELECT_TEMPLATE'
		});
	}

	setNumberOfTemplatesToGet(num): void {
		this.numberOfTemplatesToGet = num;
		this.getRecentTemplates();
    }
    
    isValidTemplate(template) {
        if ((template.destination.id && !template.destIdIsValid) || (template.origin.id && !template.originIdIsValid)) {
            return false;
        } else {
            return true;
        }
    }
}
